import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import ewa from 'assets/images/dr_ewa.jpg';
import { PATHS } from 'config/paths';
import { withLocale } from '@dietlabs/components';
import Layout from 'Layout/Layout';

class GoalLost extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        renderTimeline: PropTypes.func,
    };

    static defaultProps = {
        renderTimeline: undefined,
    };

    render() {
        return (
            <Layout page="diet">
                {this.props.renderTimeline && this.props.renderTimeline('top')}
                <section className="bg-white">
                    <Container>
                        <Row>
                            <Col xs="12" className="text-center">
                                <img
                                    className="mb-4"
                                    src={ewa}
                                    role="presentation"
                                    alt=""
                                />
                                <h1>
                                    {this.props.t('info-pages/goal-lost/title')}
                                </h1>
                                <Button
                                    color="secondary"
                                    className="mb-4"
                                    tag={Link}
                                    to={PATHS.MAKE_DECISION}
                                >
                                    {this.props.t(
                                        'info-pages/goal-lost/button'
                                    )}
                                </Button>
                                <p>
                                    {this.props.t(
                                        'info-pages/goal-lost/content'
                                    )}
                                </p>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </Layout>
        );
    }
}

export { GoalLost };
export default withLocale(GoalLost);
